












































import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import SelectBook from './SelectBook.vue'
import BookTree from './BookTree.vue'
import KnowledgeTree from './KnowledgeTree.vue'
import { getUrlParams } from '@/utils/urlUtils'
import { sa } from '@/utils/sa'

@Component({
  components: { SelectBook, BookTree, KnowledgeTree }
})
export default class LeftMenu extends Vue {
  @Prop({
    default() {
      return true
    }
  })
  haveKpChoices!: boolean
  @Prop({
    default() {
      return true
    }
  })
  haveUnionChoices!: boolean
  @Prop() isMulti!: boolean
  @Prop({
    default() {
      return true
    }
  })
  checkStrictly!: boolean
  @Prop({
    default() {
      return 3
    }
  })
  public maxKps!: number
  @Prop({
    default() {
      return undefined
    }
  })
  public pageName!: string

  public activeKey = '1'
  public checkable = false
  public radioValue = '1'
  public bookData: any = {
    series_id: '',
    grade: 0,
    bookName: '',
    gradeName: ''
  }
  public blackList = ['103']
  private isUnion = '1'

  private get subjectId() {
    return this.$store.state.subject.value
  }
  private get subject() {
    return this.$store.state.subject
  }
  @Watch('subjectId')
  onSubjectChange(val) {
    if (~~this.subjectId === 103) {
      this.activeKey = '1'
    }
    this.bookData = { series_id: '', grade: 0 }
    this.$store.commit('SET_CATALOG', '')
    this.$store.commit('SET_FACTORS', {
      checked: [],
      halfChecked: []
    })
    this.kpCheck([])
  }
  @Watch('radioValue')
  public onRadioValChange(val) {
    if (val === '2') {
      this.checkable = true
      // this.$store.commit('SET_KPS', [])
      this.$store.commit('SET_SINGLEORMULTI', '2')
    } else {
      this.checkable = false
      this.$store.commit('SET_SINGLEORMULTI', '1')
      // this.$store.commit('SET_FACTORS', {
      //   checked: [],
      //   halfChecked: []
      // })
    }
  }
  @Watch('activeKey')
  public onKeyChange(val) {
    this.$store.commit('SET_BOOKORKPS', val)
    if (val === '2') {
      setTimeout(() => {
        sa.track('ContentRepository_Top', {
          lvevl1Menu: '题目',
          lvevl2Menu: '知识点',
          subject: this.subject.label
        })
      }, 50)
    } else {
      setTimeout(() => {
        sa.track('ContentRepository_Top', {
          lvevl1Menu: '题目',
          lvevl2Menu: '章节',
          subject: this.subject.label
        })
      }, 50)
    }
  }

  public mounted() {
    this.$store.commit('SET_BOOKORKPS', '1')
    this.$store.commit('SET_SINGLEORMULTI', '1')
    this.$store.commit('SET_FACTORS', {
      checked: [],
      halfChecked: []
    })
    this.kpCheck([])
  }
  /**
   * chooseBook
   */
  public chooseBook(val) {
    console.log(val)
    if (val.series_id === this.bookData.series_id && val.grade === this.bookData.grade) {
      return
    }
    this.bookData = val
    this.$store.commit('SET_BOOK', val.grade || '')
  }
  public selectBook(val) {
    this.$store.commit('SET_CATALOG', val[0] || '')
  }
  public kpCheck(val) {
    this.$store.commit('SET_KPS', val)
    if (!val) return
    if (!val.length) return
    let arr: any = []
    for (let n of val) {
      let name = this.getName(n)
      arr = [...arr, name]
    }
    setTimeout(() => {
      sa.track('ContentRepository_Top', {
        lvevl1Menu: '题目',
        lvevl2Menu: '知识点',
        lvevl3Menu: arr,
        subject: this.subject.label
      })
    }, 50)
  }
  public getName(item) {
    let res = getUrlParams(item)
    return res ? res.title : ''
  }
  @Emit()
  public unionChange() {
    return this.isUnion
  }
  @Emit()
  public onChecked(val) {
    return val
  }
}
